function openTab(evt, tabId) {
  // Hide all tab content
  const tabContents = document.querySelectorAll('.tab-content');
  tabContents.forEach((content) => {
    content.classList.remove('active');
    content.style.display = 'none';
  });

  // Remove active class from all tab links
  const tabLinks = document.querySelectorAll('.tab-link');
  tabLinks.forEach((link) => link.classList.remove('active'));

  // Show the current tab and set active class
  const selectedTab = document.getElementById(tabId);
  selectedTab.classList.add('active');
  selectedTab.style.display = 'block';
  evt.currentTarget.classList.add('active');
}

// Initialize the first tab as active
document.addEventListener('DOMContentLoaded', () => {
  const firstTabContent = document.querySelector('.tab-content');
  const firstTabLink = document.querySelector('.tab-link');
  if (firstTabContent && firstTabLink) {
    firstTabContent.style.display = 'block';
    firstTabContent.classList.add('active');
    firstTabLink.classList.add('active');
  }
});

// Bounce the button whe visible
document.addEventListener("DOMContentLoaded", function () {
    let buttons = document.querySelectorAll("a.btn");

    let observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !entry.target.classList.contains("animated")) {
                    entry.target.classList.add("bounce-once", "animated");
                    setTimeout(() => {
                        entry.target.classList.remove("bounce-once");
                    }, 600);
                }
            });
        },
        { threshold: 0.5 }
    );

    buttons.forEach(button => {
        observer.observe(button);
    });
});

// PageFly Popup Background Scroll
document.addEventListener("DOMContentLoaded", function () {
    const popup = document.querySelector("dialog.pf-m");

    if (popup) {
        const observer = new MutationObserver(function () {
            if (popup.hasAttribute("open") && popup.style.display === "flex") {
                // Disable scrolling when popup is open
                document.body.style.overflow = "hidden";
            } else {
                // Enable scrolling when popup is closed
                document.body.style.overflow = "";
            }
        });

        observer.observe(popup, { attributes: true, attributeFilter: ["open", "style"] });
    }
});

